// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const XmarkIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="XmarkIcon" ref={forwardedRef} {...props}>
      <path d="m8.843 9.994-5.03 4.808 1.157 1.106L10 11.1l5.03 4.808 1.157-1.106-5.03-4.808 5.018-4.796-1.157-1.106L10 8.89 4.982 4.092 3.825 5.198z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const XmarkIcon = /* @__PURE__ */ Object.assign(XmarkIconComponent, {
  displayName: 'XmarkIcon',
});
